__turbopack_context__.v({
  "accessIcon": "style-module-scss-module__DrvlSq__accessIcon",
  "card": "style-module-scss-module__DrvlSq__card",
  "cardIcon": "style-module-scss-module__DrvlSq__cardIcon",
  "cardText": "style-module-scss-module__DrvlSq__cardText",
  "cardTitle": "style-module-scss-module__DrvlSq__cardTitle",
  "cardsGrid": "style-module-scss-module__DrvlSq__cardsGrid",
  "commuteAddress": "style-module-scss-module__DrvlSq__commuteAddress",
  "commuteContent": "style-module-scss-module__DrvlSq__commuteContent",
  "commuteIcon": "style-module-scss-module__DrvlSq__commuteIcon",
  "commuteInfo": "style-module-scss-module__DrvlSq__commuteInfo",
  "commuteMax": "style-module-scss-module__DrvlSq__commuteMax",
  "commuteTitle": "style-module-scss-module__DrvlSq__commuteTitle",
  "component": "style-module-scss-module__DrvlSq__component",
  "description": "style-module-scss-module__DrvlSq__description",
  "dot": "style-module-scss-module__DrvlSq__dot",
  "dotActive": "style-module-scss-module__DrvlSq__dotActive",
  "driveIcon": "style-module-scss-module__DrvlSq__driveIcon",
  "heading": "style-module-scss-module__DrvlSq__heading",
  "importanceBar": "style-module-scss-module__DrvlSq__importanceBar",
  "importanceLabel": "style-module-scss-module__DrvlSq__importanceLabel",
  "petIcon": "style-module-scss-module__DrvlSq__petIcon",
  "transitIcon": "style-module-scss-module__DrvlSq__transitIcon",
  "walkIcon": "style-module-scss-module__DrvlSq__walkIcon",
});
